<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Search Inventory</span>
          </div>
          <div class="card-body">
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <label for="name">Shop Name </label>
                  <span style="display: flex;">
                    <model-list-select
                      :list="shopname"
                      option-value="est_shop_id"
                      option-text="est_shop_name"
                      v-model="selectshop"
                      placeholder="Select Shop"
                      style="
                        -webkit-text-fill-color: rgb(83, 108, 121) !important;
                        height: 20px !important;
                        border: 1px solid rgb(194, 207, 214);
                        min-height: 35px;
                      "
                    ></model-list-select>
                  </span>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="name">Select Product</label>
                  <model-list-select
                    :list="productnamex"
                    option-value="product_id"
                    option-text="product_name"
                    v-model="selectproduct"
                    placeholder="Search Product Name"
                    @input="openvariant()"
                    @searchchange="searchprd3($event)"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 20px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 35px;
                    "
                    class="product-drop"
                  >
                  </model-list-select>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label for="name">Select Variant</label>
                  <model-list-select
                    :list="variantvalue"
                    option-value="variant_value"
                    option-text="variant_value"
                    v-model="selectvariant"
                    placeholder="Search Variant"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 20px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 35px;
                    "
                    class="product-drop"
                  >
                  </model-list-select>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <button
                    type="button"
                    style="margin-top: 24px; margin-left: 16%;"
                    class="btn btn-pill btn-primary serach_bttn"
                    @click="search"
                  >
                    <i class="fa fa-search"></i>&nbsp;Search
                  </button>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div slot="header">
              <div class="row">
                <div class="col-sm-9">
                  <span class="title_head">Stock Inventory</span>
                  <p v-show="hide">{{ invt_view }}</p>
                </div>
                <!-- <span class="title_head">Stock Inventory</span><p v-show="hide">{{ invt_view }}</p> -->
                <!-- <span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
                <!-- <a href="#/sales/addsales" v-if="sale_rights === true" -->
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div class="col-sm-1">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary label_bttn"
                    @click.prevent="exportData()"
                  >
                    <i class=""></i> Export Data
                  </button>
                  <!-- </a -->
                </div>
                <!-- </span> -->
              </div>
            </div>
          </div>
          <div class="card-body">
            <vue-good-table
              :columns="columns"
              :rows="rows"
              mode="remote"
              ref="my-table"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :pagination-options="{ enabled: true, perPage: 10 }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'exp_sellprice_bft_lbl'">
                  <span v-if="props.row.id == inventory.id">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Sale Price"
                      v-model="inventory.price_bft"
                    />
                  </span>
                  <span v-else>
                    {{ formatFn(props.row.exp_sellprice_bft) }}
                  </span>
                </span>
                <span v-if="props.column.field == 'variant_value'">
                  <span v-if="props.row.variant_id == 'n/a'">
                    No Variant
                  </span>
                  <span v-else>
                    {{ props.row.variant_id }}
                  </span>
                </span>

                <span v-if="props.column.field == 'action'">
                  <span v-if="invt_rights === true">
                    <span v-if="props.row.id == inventory.id">
                      <i
                        class="fa fa-save"
                        @click.prevent="update_inventory(props.row)"
                      ></i>
                    </span>
                    <span v-else>
                      <i
                        class="fa fa-edit"
                        @click.prevent="edit_inventory(props.row)"
                      ></i>
                    </span>
                  </span>
                  <span v-else>
                    <i class="fa fa-edit" style="color: grey !important;"></i>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Spinner from "../spinner.vue";
export default {
  name: "Shopinventory",
  components: {
    Spinner,
    "date-picker": DatePicker,
  },
  data() {
    return {
      // pg_view:false,
      // pg_rights:false,
      shopname: [],
      productnamex: [],
      variantvalue: [],
      selectvariant: null,
      selectshop: null,
      selectproduct: null,
      shpfrst_time: false,
      ifrst_time: false,
      ssfrst_time: false,
      hide: false,
      largeModal1: false,
      largeModal: false,
      loading: false,
      inventory: {
        id: "",
        product_id: "",
        est_shop_id: "",
        price_bft: "",
        price_bft: "",
      },
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          // field: 'purchase_id',
          // type: 'asc',
        },
        page: 1,
        perPage: 10,
      },
      columns: [
        {
          label: "Product Name ",
          field: "product_name",
          width: "25%",
        },
        {
          label: "Qty",
          field: "quantity",
          width: "5%",
        },
        {
          label: "Variant",
          field: "variant_value",
          width: "15%",
        },
        {
          label: "Shop",
          field: "est_shop_name",
          width: "20%",
        },
        {
          label: "Tax",
          field: "tax_inclusive",
          formatFn: this.formatTax,
          width: "10%",
        },
        {
          label: "Purchase Price",
          field: "last_purprice_bft",
          formatFn: this.formatFn,
          width: "10%",
        },
        {
          label: "Sale Price",
          field: "exp_sellprice_bft_lbl",
          formatFn: this.formatFn,
          width: "10%",
        },
        {
          label: "Edit",
          field: "action",
          width: "5%",
        },
      ],
      rows: [],
    };
  },
  computed: {
    invt_view: function () {
      if (this.$store.getters.get_invt_view === true) {
        this.getinventory("comp");
        this.searchshops("comp");
        this.shopuser("comp");
        return true;
      } else {
        return false;
      }
    },

    invt_rights: function () {
      return this.$store.getters.get_invt_rights;
    },
  },
  // created(){
  // var roles = JSON.parse(localStorage.getItem('roles'))
  // if(roles[16].page_name == 17){
  //   this.pg_view = roles[16].view
  //   this.pg_rights = roles[16].rights
  //   if(this.pg_view){
  //     this.getinventory();
  //     this.shopuser();
  //   }
  // }
  // },
  methods: {
    search() {
      this.getinventory();
    },

    openvariant() {
      this.variantvalue = [];
      var _this = this;
      this.selectvariant = null;
      var vrnt_id =
        this.selectproduct == null ? null : this.selectproduct.variant_id;
      if (vrnt_id !== null) {
        this.$http
          .get("/api/variantvalues?filter[where][variant_id]=" + vrnt_id)
          .then(function (response) {
            _this.variantvalue = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    searchprd3(searchText) {
      var _this = this;
      this.productnamex = [];
      this.selectproduct = null;
      this.$http
        .get("/api/purchasereturns/joinproduct2?data=" + searchText)
        .then(function (response) {
          _this.productnamex = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    searchshops(val) {
      if (val === "comp") {
        if (this.ssfrst_time === false) {
          this.ssfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.shopname = [];
      this.selectshop = null;
      this.$http
        .get("/api/shopusers/getShop")
        .then(function (response) {
          _this.shopname = response.data;
        })
        .catch(function (er) {
          console.log(er);
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getinventory();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getinventory();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.getinventory();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.getinventory();
    },

    shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },
    formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    formatTax(value) {
      if (value === true) {
        return "Inclusive";
      } else {
        return "Exclusive";
      }
    },
    getinventory(val) {
      if (val === "comp") {
        if (this.ifrst_time === false) {
          this.ifrst_time = true;
        } else {
          return;
        }
      }
      this.loading = true;
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      // console.log(this.selectshop)
      // console.log(this.selectproduct)
      // console.log(this.selectvariant)
      var filter = "";
      if (
        this.selectshop !== null &&
        this.selectshop.est_shop_id !== undefined
      ) {
        filter += "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }

      if (
        this.selectproduct !== null &&
        this.selectproduct.product_id !== undefined
      ) {
        filter += "&filter[where][product_id]=" + this.selectproduct.product_id;
      }

      if (
        this.selectvariant !== null &&
        this.selectvariant.variant_id !== undefined
      ) {
        filter +=
          "&filter[where][variant_id]=" + this.selectvariant.variant_value;
      }

      // console.log(filter)
      this.$http
        .get(
          "/api/estshopinventories/getstock?params=" +
            JSON.stringify(filteParam) +
            filter
        )
        .then(function (response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows = response.data;
          _this.loading = false;
        });
    },
    edit_inventory(inventory) {
      (this.inventory.id = inventory.id),
        (this.inventory.product_id = inventory.product_id),
        (this.inventory.est_shop_id = inventory.est_shop_id);
      /*        this.inventory.price_bft = inventory.exp_sellprice_bft,*/
      this.inventory.price_bft = parseFloat(
        inventory.exp_sellprice_bft
      ).toFixed(2);
    },
    update_inventory(inventory) {
      // console.log(inventory.variant_id)

      // var num=/^[0-9]{1,11}$/
      var num = /^\d{1,12}(\.\d{1,6})?$/;

      if (this.inventory.price_bft == "") {
        alert("Please Provide Sale Price");
      } else if (
        num.test(this.inventory.price_bft) == false &&
        this.inventory.price_bft != ""
      ) {
        this.inventory.price_bft = "";
        alert("Please Provide Valid Sale Price");
      } else if (parseFloat(this.inventory.price_bft) <= 0) {
        this.inventory.price_bft = "";
        alert("Please Provide Valid Sale Price");
      } else {
        var _this = this;
        var data = {
          cmp_product_id: this.inventory.product_id,
          cmp_est_shop_id: this.inventory.est_shop_id,
          // exp_sellprice_bft:this.inventory.price_bft,
          exp_sellprice_bft: this.inventory.price_bft,
          cmp_variant_id: inventory.variant_id,
        };

        this.loading = true;
        this.$http
          .post(
            "/api/estshopinventories/update?where[product_id]=" +
              inventory.product_id,
            data
          )
          .then(function (response) {
            _this.loading = false;
            _this.getinventory();
            _this.inventory.id = "";
          })
          .catch(function (error) {});
      }
    },
    //Nishith Changes For Excel Report
    exportData() {
      // alert('data')
      this.loading = true;
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var filter = "";
      if (
        this.selectshop !== null &&
        this.selectshop.est_shop_id !== undefined
      ) {
        filter += "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }

      if (
        this.selectproduct !== null &&
        this.selectproduct.product_id !== undefined
      ) {
        filter += "&filter[where][product_id]=" + this.selectproduct.product_id;
      }

      if (
        this.selectvariant !== null &&
        this.selectvariant.variant_id !== undefined
      ) {
        filter +=
          "&filter[where][variant_id]=" + this.selectvariant.variant_value;
      }

      if(this.rows.length > 0){

      this.$http
        .get(
          "/api/estshopinventories/getshopinventoryExport?params=" +
            JSON.stringify(filteParam) +
            filter
        )
        .then(function (response) {
          // console.log(response)
          _this.loading = false;
          //  alert('isslke paas')
          var access_token = localStorage.getItem("authUser");
          // console.log(response.data)
          var url1 =
            _this.baseURL2 +
            "/api/containers/csv/download/" +
            response.data +
            "?access_token=" +
            access_token;
          // console.log('url  '  + url1)
          // var url1 = '/api/containers/csv/download/1593025721009.csv';
          _this
            .$http({
              url: url1,
              method: "GET",
              responseType: "blob",
            })
            .then((res) => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.setAttribute("download", response.data);
              link.href = url1;
              document.body.appendChild(link);
              link.click();
              _this.loading = false;
            })
            .catch(function (er) {
              console.log(er);
              _this.loading = false;
            });

          ///End OF Exce Downlod Method...
        });
      } else {
        _this.loading = false;
        alert('No Data Found')
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ShopInventory.vue